var r;(function(o){o.NOT_FOUND="404 Not Found",o.FAILURE="Failure"})(r||(r={}));var n;(function(o){o.LOADING="loading",o.ERROR="error",o.IDLE="idle"})(n||(n={}));export{r as ErrorCode,n as RequestStateType};
//# sourceMappingURL=RequestState.es.js.map
